











import useReplies from "@/composables/v2.1/useReplies";
import { useChatsStore } from "@/store/useChatsStore";
import { defineComponent } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
    },
    props: {
        entryId: {
            type: Number,
            required: true,
        },
        isAttachment: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const chatsStore = useChatsStore();
        const { addReply } = useReplies();

        return {
            chatsStore,
            addReply,
        };
    },
});
